import { render } from "./payment-queue.vue?vue&type=template&id=fdf9920c&lang=html"
import script from "./payment-queue.vue?vue&type=script&lang=js"
export * from "./payment-queue.vue?vue&type=script&lang=js"

import "./payment-queue.vue?vue&type=style&index=0&id=fdf9920c&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__